<template>
    <v-card color="#F4FEFB">
        <v-card-title>
            チェックボックスの設定
        </v-card-title>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <badge-component tile content="必 須" color="red">
                  <label-component>入力者</label-component>
              </badge-component>
              <v-select
                :items="selectDestinations"
                outlined
                hide-details
                v-on:change="changeUserId"
                v-model="selected"
                background-color="white"
              >
              </v-select>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-checkbox
                v-model="defaultValue"
                label="初期値としてチェックを入れる"
                color="blue"
                hide-details
                v-on:change="changeDefault"
              ></v-checkbox>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-checkbox
                v-model="checkRequired"
                label="必須項目にする"
                color="blue"
                hide-details
                v-on:change="changeRequire"
              ></v-checkbox>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
export default {
    props: ['destinations', 'destinationId', 'require', 'defaultValue'],
    data: function () {
        return {
            selectDestinations: [],
            checkRequired: false,
            selected: 0,
        };
    },
    created: function () {
        this.selected = this.destinationId;
        Object.entries(this.destinations).forEach((val, index) => {
            this.selectDestinations.push({
                text: val[1].destination_user_name,
                value: val[1].id
            });
        });
        this.checkRequired = this.require;
        
    },
    methods: {
      changeUserId: function (e) {
        this.$emit('changeUserId', e);
      },
      changeDefault: function (e) {
        this.$emit('changeDefault', e);
      },
      changeRequire: function (e) {
        this.$emit('changeRequire', e);
      },
    }
}
</script>

<style scoped>

</style>